// src/components/ContentCard/CardContent.js
import React from 'react';
import StyledContentContainer from '../../../../components/card/StyledContentContainer';
import CardDescription from '../../../../components/card/CardDescription';
import CardTitle from '../../../../components/card/CardTitle';

const CardContent = ({ title, description, children }) => (
  <StyledContentContainer>
    <CardTitle>{title}</CardTitle>
    <CardDescription>{description}</CardDescription>
    {children}
  </StyledContentContainer>
);

export default CardContent;